import { ContentDirective } from './content/content.directive';

export const sharedDirectives: any[] = [
  ContentDirective,
];

export * from './content/content.directive';
